export const marketingActions = {
  bookVisit: "Book a Care Visit",
  talkToExpert: "Talk to Care Expert",
} as const;

export const careStandardsIntro =
  "Every home visit is delivered by trained, verified professionals following standardized care protocols.";
export const appDownloadDescription =
  "Download the Carevinco app and manage care with confidence, transparency, and complete peace of mind.";
export const footerCareDescription = "Professional nursing care is just a few clicks away.";

export const careJourneySteps = [
  {
    number: "01",
    title: "Tell Us What You Need",
    nurseTitle: "Tell Us Your Care Needs",
    image: "step-needs.png",
    tone: "stepBlue",
  },
  { number: "02", title: "Choose Your Nurse", image: "step-nurse.png", tone: "stepOrange" },
  { number: "03", title: "Care Begins at Home", image: "step-care.png", tone: "stepGreen" },
  { number: "04", title: "Stay Updated", image: "step-updated.png", tone: "stepPurple" },
] as const;

export const trustHeading = {
  eyebrow: "Families Trust Carevinco",
  lead: "Professional Care. ",
  accent: "Proven",
  ending: " Every Day.",
} as const;
